// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_classnames_index_js-node_modules_lodash_lodash_js-node_modules_swiper_sw-7e9fda"], () => (__webpack_require__("./src/index.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
